
export const esReportVersion = 8;